import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ProjectService} from '../project/project.service';
import {GalleryOverview} from '../model/galleryOverview';
import {ClickEvent} from '../project/pagination/pagination.component';
import {DOCUMENT} from '@angular/common';
import {Respondent} from '../model/respondent';
import {GalleryUnitElement} from '../model/GalleryUnitElement';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';

@Component({
  selector:'hastag-gallery',
  template:`
    <nav class="navbar navbar-dark bg-dark">
      <!-- Navbar content -->
      <div>
        <button class="btn btn-outline-primary" (click)="backToApp()"><span class="backArrow"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></span></button>
        <button class="btn btn-primary" id="menu-toggle" onclick="toggleSideBar()"><span class="sideBarBtn"><i class=" fas fa-bars" aria-hidden="true"></i></span></button>
      </div>
      <div class="title" id="navbarText">
        <a class="nav-link" ><span><img width="53px" height="53px" alt="icon" src="../../assets/images/Pictures-Canon-icon.png"></span>Photo Gallery <span class="sr-only">(current)</span></a>
      </div>
      <form class="form-inline">
        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
        <button class="btn btn-outline-primary my-2 my-sm-0" type="submit">Search</button>
      </form>
    </nav>
    <div class="d-flex" id="wrapper">

    <informationSideBar *ngIf="gallery!=null" [pId]="gallery.pId" [qId]="gallery.qId" [otherFolders]="gallery.otherFolders" [totalResp]="gallery.totalResp" [projectName]="gallery.projectName" (selected)="updateGallery($event)"></informationSideBar>
      <div id="page-content-wrapper">
          <body>
          <div class="container">
            <div class="gallery">

              <div *ngFor="let url of this.activeGalleryLinks" class="gallery-item">
                <img class="gallery-image" [src]="url" (click)="downloadImg(url)"
                     alt="iBrand image, Hashtag image">
                <div><a [href]="downloadImg(url)"><span class="downloadImgBtn"><i class="fas fa-download"></i></span></a></div>
              </div>

              <div class="gallery-item">
                <img class="gallery-image" src="https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?w=500&h=500&fit=crop"
                     alt="person writing in a notebook beside by an iPad, laptop, printed photos, spectacles, and a cup of coffee on a saucer">
              </div>

              <div class="gallery-item">
                <img class="gallery-image" src="https://images.unsplash.com/photo-1515260268569-9271009adfdb?w=500&h=500&fit=crop"
                     alt="sunset behind San Francisco city skyline">
              </div>

              <div class="gallery-item">
                <img class="gallery-image" src="https://images.unsplash.com/photo-1506045412240-22980140a405?w=500&h=500&fit=crop"
                     alt="people holding umbrellas on a busy street at night lit by street lights and illuminated signs in Tokyo, Japan">
              </div>

              <div class="gallery-item">
                <img class="gallery-image" src="https://images.unsplash.com/photo-1514041181368-bca62cceffcd?w=500&h=500&fit=crop"
                     alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night">
              </div>

              <div class="gallery-item">
                <img class="gallery-image" src="https://images.unsplash.com/photo-1445810694374-0a94739e4a03?w=500&h=500&fit=crop"
                     alt="back view of woman wearing a backpack and beanie waiting to cross the road on a busy street at night in New York City, USA">
              </div>

              <div class="gallery-item">
                <img class="gallery-image" src="https://images.unsplash.com/photo-1486334803289-1623f249dd1e?w=500&h=500&fit=crop"
                     alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp">
              </div>

            </div>

          </div>
          </body>
        <div *ngIf="gallery!=null" class="paginationContainer row col-md-12">
          <paginationGadget (changeValue)="updateItemPerPage($event)"></paginationGadget>
          <div class="paginationComponent">
            <pagination
              [item-can-change]="true"
              [indexSelectedItem]="this.pageNumber"
              [item-by-page]="itemsPerPage"
              [total-nb-respondents]="gallery.totalResp"
              (beforePageChange)="onBeforePageChange($event)"
              (go)="onBeforePageChange($event)"></pagination>
          </div>
        </div>
      </div>
    </div>`,
  styles:[`

    body{padding-top: 85px;}
    .downloadImgBtn{color: white;}
    .paginationContainer{margin-left: 30%;}
    paginationGadget{margin-top: 8px;}

    .btn{float: left;margin-left: 15px;}
    .backArrow,.sideBarBtn{font-size: 20px;}
    .title{color:white;font-size: 35px;}
    /*

All grid code is placed in a 'supports' rule (feature query) at the bottom of the CSS (Line 77).

The 'supports' rule will only run if your browser supports CSS grid.

Flexbox is used as a fallback so that browsers which don't support grid will still recieve an identical layout.

*/
  @import url(https://fonts.googleapis.com/css?family=Montserrat:500);

  :root {
    /* Base font size */
    font-size: 10px;
    background-color: #313131;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body {
    min-height: 100vh;
    background-color: #313131;
  }

  .container {
    max-width: 100rem;
    margin: 0 auto;
    padding: 0 2rem 2rem;
    background-color: #313131;
  }

  .heading {
    font-family: "Montserrat", Arial, sans-serif;
    font-size: 4rem;
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
    padding: 3.5rem 0;
    color: #1a1a1a;
  }

  .heading span {
    display: block;
  }

  .gallery {
    display: flex;
    flex-wrap: wrap;
    /* Compensate for excess margin on outer gallery flex items */
    margin: -1rem -1rem;
  }

  .gallery-item {
    /* Minimum width of 24rem and grow to fit available space */
    flex: 1 0 24rem;
    /* Margin value should be half of grid-gap value as margins on flex items don't collapse */
    margin: 1rem;
    box-shadow: 0.3rem 0.4rem 0.4rem rgba(0, 0, 0, 0.4);
    overflow: hidden;
  }

  .gallery-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 400ms ease-out;
  }

  .gallery-image:hover {
    transform: scale(1.15);
  }

  /*

  The following rule will only run if your browser supports CSS grid.

  Remove or comment-out the code block below to see how the browser will fall-back to flexbox styling.

  */

  @supports (display: grid) {
    .gallery {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(24rem, 1fr));
      grid-gap: 2rem;
    }

    .gallery,
    .gallery-item {
      margin: 0;
    }
  }
  `]
})

export class GalleryComponent implements OnInit {

  private gallery: GalleryOverview;

  private itemsPerPage = 25;

  private pageNumber:number;

  private activeGalleryLinks:string[];

  private pId:number;

  private qId:number;

  constructor(private router: Router, private route: ActivatedRoute, private projectService: ProjectService,@Inject(DOCUMENT) private document:Document) {

  }


  ngOnInit(): void {
    // TODO: change hard coded parameters later with real applicable data
    // TODO: Continue Monday from here; Must use subscription and unsubscribe on destroy
    this.route.params.subscribe((next: Params) => {

      this.qId = next['qId'];
      this.pId = next['pId'];

      this.getImageUrls('pictures');
    });

  }

  private backToApp() {
    this.router.navigate(['/main']);
  }

  updateGallery(folderName: string) {
    this.getImageUrls(folderName);
  }

  private getImageUrls(folderName:string) {
    this.projectService.getRespondentsByRange(0,-1,-1,-1,this.pId,this.qId,-1,true,'','').subscribe((result) => {

      const respArr = Json2TypescriptUtil.getJsonConvertInstance().deserializeArray(result,Respondent);
      this.gallery = new GalleryOverview(null);
      this.gallery.totalResp = respArr.length;
      this.gallery.pId = this.pId;
      this.gallery.qId = this.qId;
      /*const respArr = new Array<Respondent>();
      for(let i = 0; i< respondents.length;i++) {
        respArr.push(new Respondent(respondents[i]));
      }*/
      for(const resp of respArr) {
        for(const ans of resp.Answers) {
          if(ans.answer.includes('jpg') && ans.answer.includes(folderName)) {
            const galleryUnit = new GalleryUnitElement(null);
            galleryUnit.setToken(resp.token);
            galleryUnit.setImgUrl('http://localhost:8080/'+ans.answer);
            this.gallery.insertGalleryUnit(galleryUnit);
          }
        }
      }
      this.activeGalleryLinks = this.gallery.getImgLinks().slice(0,26);
    });
  }

  onBeforePageChange($event:ClickEvent) {
    if ( $event.index > 0  ) {
      this.pageNumber = $event.index;
      const startIndex = this.pageNumber -1;
      this.activeGalleryLinks = this.gallery.getImgLinks().slice(startIndex*this.itemsPerPage,this.itemsPerPage+1);
    }
  }

  updateItemPerPage($event: number) {
    this.itemsPerPage = $event;
    this.activeGalleryLinks = this.gallery.getImgLinks().slice((this.pageNumber -1)*this.itemsPerPage,this.itemsPerPage+1);
  }

  private downloadImg(url:string):string {

    const host = 'http://'+this.document.location.hostname+':8080';
    const path = url.substr(url.indexOf('projects'),url.length).split('\\').join('/');
    return host+'/projects/hashtag/?link='+path;
  }
}


